import { OrderStatus } from '@services/core/types';

export type OrderStatusBadgeColor = 'success' | 'warning' | 'error' | 'info' | 'gray';

export const ORDER_STATUS_BADGE: Record<OrderStatus, { color: OrderStatusBadgeColor; label: string }> = {
  PENDING: { color: 'warning', label: 'Pending' },
  CONFIRMED: { color: 'info', label: 'Confirmed' },
  PROCESSING: { color: 'info', label: 'Processing' },
  SHIPPED: { color: 'info', label: 'Shipped' },
  DELIVERED: { color: 'success', label: 'Delivered' },
  CANCELLED: { color: 'error', label: 'Cancelled' },
  REFUNDED: { color: 'gray', label: 'Refunded' },
  REJECTED: { color: 'error', label: 'Rejected' },
  ARCHIVED: { color: 'gray', label: 'Archived' },
  READY_FOR_PICKUP: { color: 'info', label: 'Ready for Pickup' },
  FINISHED: { color: 'success', label: 'Finished' },
  NOT_PICKED_UP: { color: 'error', label: 'Not Picked Up' },
};
